import {
  AuthToken,
  AuthTokenBody,
  ConfirmResetPasswordBody,
  MfaRequired,
  VerifyEmailBody,
  VerifyMfaBody
} from '@bioliberty/lifemind';
import { tms } from './tms';

export type ExchangeAuthorizationCode = AuthTokenBody & {
  redirectUri?: string;
};

export type ConfirmResetPassword = ConfirmResetPasswordBody & {
  userId: string;
};

const auth = tms.injectEndpoints({
  endpoints: (builder) => ({
    exchangeAuthorizationCode: builder.mutation<AuthToken | MfaRequired, ExchangeAuthorizationCode>({
      query: ({ redirectUri, ...body }) => ({
        url: `authorize/token${redirectUri ? `?redirect_uri=${encodeURIComponent(redirectUri)}` : ''}`,
        method: 'POST',
        body: body
      })
    }),

    verifyMfa: builder.mutation<AuthToken, VerifyMfaBody>({
      query: (body) => ({
        url: 'authorize/token/verify',
        method: 'POST',
        body
      })
    }),

    resetPassword: builder.mutation<void, string>({
      query: (id) => ({
        url: `users/${id}/password`,
        method: 'DELETE'
      })
    }),

    confirmResetPassword: builder.mutation<void, ConfirmResetPassword>({
      query: ({ userId, confirmationCode, password }) => ({
        url: `users/${userId}/password`,
        method: 'POST',
        body: { confirmationCode, password }
      })
    }),

    verifyEmail: builder.mutation<void, VerifyEmailBody>({
      query: (body) => ({
        url: `verify-email`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['Profile', 'Users']
    })
  }),
  overrideExisting: false
});

export const {
  useExchangeAuthorizationCodeMutation,
  useResetPasswordMutation,
  useConfirmResetPasswordMutation,
  useVerifyEmailMutation,
  useVerifyMfaMutation
} = auth;
